import { render, staticRenderFns } from "./BeCardNotification.vue?vue&type=template&id=2166c51b&scoped=true"
import script from "./BeCardNotification.vue?vue&type=script&lang=js"
export * from "./BeCardNotification.vue?vue&type=script&lang=js"
import style0 from "./BeCardNotification.vue?vue&type=style&index=0&id=2166c51b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2166c51b",
  null
  
)

export default component.exports